import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import docLogo from "../../images/layout/docLogo.png"
import fb from "../../images/layout/fb.png"
import google from "../../images/layout/google.png"
import yelp from "../../images/layout/yelp.png"

const Section = styled.footer`
  background: ${({ theme }) => theme.dark};
  padding: 32px 0px;
  color: ${({ theme }) => theme.white};
  text-align: center;
`
const Links = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 64px 0;
  list-style: none;
  padding: 0;

  li {
    margin-bottom: 16px;

    :last-of-type {
      margin-bottom: 0;
    }
  }

  @media (min-width: 768px) {
    margin: 80px -32px 48px 0;
    flex-direction: row;
    flex-wrap: wrap;

    li {
      margin-bottom: 32px;
      margin-right: 32px;

      :last-of-type {
        margin-bottom: 32px;
      }
    }
  }
`

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.white};

  :hover,
  :focus {
    color: ${({ theme }) => theme.blue};
  }
`

const TwoLinks = styled.div`
  text-align: center;
  padding-top: 16px;
  position: relative;
  border-top: 1px solid #c4c4c4;
  margin: 64px auto 0;
  max-width: 984px;

  a:first-of-type {
    margin-right: 32px;
  }
`

const Icons = styled.div`
  p:first-of-type {
    font-weight: 700;
    margin-bottom: 32px;
  }

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;

    p:first-of-type {
      margin: 0 32px 0 0;
    }
  }
`

const Box = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  justify-content: center;
`

const Img = styled.img`
  display: inline-block;
  margin-right: 30px;
  @media (max-width: 450px) {
    margin-right: 25px;
  }
`

const Power = styled.p`
  margin-bottom: 0px;
  font-size: 0.75rem;
  line-height: 1.22em;
  letter-spacing: 0.25em;

  a {
    color: ${({ theme }) => theme.white};

    :hover,
    :focus {
      color: ${({ theme }) => theme.blue};
    }
  }
`

export default function Footer() {
  return (
    <Section>
      <div className="container">
        <StaticImage
          src="../../images/layout/white-logo.png"
          alt="chamberlain logo"
          placeholder="blurred"
          width={240}
        />
        <Links>
          <li>
            <FooterLink to="/services/dental-implants/">
              DENTAL IMPLANTS
            </FooterLink>
          </li>

          <li>
            <FooterLink to="/services/porcelain-veneers/">
              PORCELAIN VENEERS
            </FooterLink>
          </li>

          <li>
            <FooterLink to="/services/sleep-apnea/">
              SLEEP APNEA DENTIST
            </FooterLink>
          </li>

          <li>
            <FooterLink to="/services/sedation-dentistry/">
              IV SEDATION DENTISTRY
            </FooterLink>
          </li>

          <li>
            <FooterLink to="/services/cosmetic-dentistry/">
              COSMETIC DENTISTRY
            </FooterLink>
          </li>

          <li>
            <FooterLink to="/about-us/">ABOUT US</FooterLink>
          </li>

          <li>
            <FooterLink to="/contact-us/">CONTACT US</FooterLink>
          </li>

          <li>
            <FooterLink to="/blog/">BLOG</FooterLink>
          </li>
        </Links>

        <Icons>
          <p>FOLLOW US:</p>

          <a
            href="https://www.facebook.com/ChamberlainDental"
            css={css`
              margin-right: 32px;
            `}
          >
            <img
              src={fb}
              width={27}
              height={27}
              alt="chamberlain facebook"
              css={css`
                display: inline-block;
              `}
            />
          </a>
          <a
            href="https://www.google.com/maps/place/Chamberlain+Dental/@27.9592181,-82.7551868,18z/data=!3m1!4b1!4m15!1m7!3m6!1s0x88c2f037a90ba845:0xbda47721e719967e!2s525-575+S+Hercules+Ave+%23403,+Clearwater,+FL+33764!3b1!8m2!3d27.9592437!4d-82.7539434!3m6!1s0x88c2f037b3d3c605:0x5da172edf40131b4!8m2!3d27.9592159!4d-82.7542363!9m1!1b1?hl=en"
            css={css`
              margin-right: 32px;
            `}
          >
            <img
              src={google}
              width={27}
              height={27}
              alt="chamberlain google reviews"
              css={css`
                display: inline-block;
              `}
            />
          </a>
          <a href="https://www.yelp.com/biz/chamberlain-general-and-sedation-dentistry-clearwater">
            <img
              width={23}
              height={27}
              src={yelp}
              alt="chamberlain yelp"
              css={css`
                display: inline-block;
              `}
            />
          </a>
        </Icons>

        <TwoLinks>
          <FooterLink to="/sitemap-pages.xml">Sitemap</FooterLink>
          <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
        </TwoLinks>

        <Box>
          <Img src={docLogo} alt="logo" width={25} height={35} />
          <Power>
            POWERED BY <a href="https://moderndocmedia.com">MODERN DOC MEDIA</a>
            .
          </Power>
        </Box>
        <p style={{ marginTop: "1em" }}>
          CHAMBERLAIN DENTAL. ALL RIGHTS RESERVED © {new Date().getFullYear()}
        </p>
      </div>
    </Section>
  )
}
